<script lang="ts">
  import { cn } from "@/lib/utils";

  export let title: string;
  export let icon: string;
  export let count: string;
  export let subtitle: string;
  export let previousYear: string;
  export let isFlipped: boolean;
  export let isActive: boolean;
  export let color: string = '#5ee6e8';

</script>

<div class={cn('w-full rounded-2xl p-[1px] transition-transform',
    isActive ? 'scale-[1.0]' : 'scale-[0.8]',
    isFlipped ? 'rotate-y-180' : '',
  )}
  style='background: linear-gradient(5deg, rgba(18,20,22,1) 60%, rgba(40,44,48,0.18) 85%, rgba(94,230,232,0.10) 100%); box-shadow: 0 8px 24px rgba(0,0,0,0.35), inset 0 0 8px rgba(255,255,255,0.04);'
>
  <div class='rounded-2xl bg-[radial-gradient(circle_at_80%_10%,rgba(255,255,255,0.06),transparent_40%),radial-gradient(circle_at_80%_90%,rgba(255,255,255,0.04),transparent_40%),linear-gradient(180deg,rgba(18,20,22,0.95),rgba(8,9,10,0.98))]'>
    <div class={cn('w-full flex flex-col items-center justify-center p-4 gap-4 text-off-white overflow-hidden')}>
      <div class={cn('w-full flex flex-col items-center justify-center gap-1 pt-1 start-hidden anim-delay-200')} class:slide-in-top={isFlipped}>
        <span class='text-xl font-bold tracking-wide'>{title}</span>
      </div>
      <i class={cn(icon, 'fa-5x fa-light')} style={`color: ${color}; ${ isFlipped ? `text-shadow: 0 0 30px ${color};` : ''}`}></i>
      <div class='w-full flex flex-col items-center gap-1 text-center px-2'>
        <span class='text-xl font-semibold tracking-wider start-hidden anim-delay-400' class:slide-in-right={isFlipped}>{count}</span>
        <span class='text-lg font-light start-hidden anim-delay-1300' class:slide-in-left={isFlipped}>{subtitle}</span>
        <span class='text-base tracking-wide mt-1 start-hidden anim-delay-1500' style={`color: ${color};`} class:slide-in-bottom={isFlipped}>{previousYear}</span>
      </div>
    </div>
    <div class='w-full h-4 flex flex-row gap-1 items-center overflow-hidden justify-center rounded-b-2xl start-hidden anim-delay-200' class:slide-in-bottom={isFlipped} style={`background: ${color};`}>
      {#each Array(30) as _, i}
        <i class={`fa-light ${icon} fa-2xs`} style="color: rgba(0,0,0,0.4);" />
      {/each}
    </div>
  </div>
</div>

<style>
  /* Title animates when layout shifts (position changes) */
  .animated-title {
    transition: transform 1200ms ease, height 1200ms ease;
  }

  /* Image expands from a dot in the center */
  .img-pop-in {
    transform-origin: center center;
    animation: img-pop-in-key 500ms ease-out both;
  }
  @keyframes img-pop-in-key {
    0% { transform: scale(0); opacity: 0; }
    60% { transform: scale(1.05); opacity: 1; }
    100% { transform: scale(1); opacity: 1; }
  }

  .start-hidden {
    opacity: 0;
  }

  /* Slide-ins clipped to card via overflow-hidden on parent */
  .slide-in-right { animation: slide-in-right-key 420ms ease-out both; }
  .slide-in-left  { animation: slide-in-left-key  420ms ease-out both; }
  .slide-in-bottom{ animation: slide-in-bottom-key 420ms ease-out both; }
  .slide-in-top{ animation: slide-in-top-key 420ms ease-out both; }
  /* Stagger helpers for animation-delay */
  .anim-delay-200 { animation-delay: 200ms; }
  .anim-delay-400 { animation-delay: 400ms; }
  .anim-delay-600 { animation-delay: 600ms; }
  .anim-delay-1300 { animation-delay: 1300ms; }
  .anim-delay-1500 { animation-delay: 1500ms; }
  @keyframes slide-in-right-key {
    0% { transform: translateX(24px); opacity: 0; }
    100%{ transform: translateX(0);    opacity: 1; }
  }
  @keyframes slide-in-left-key {
    0% { transform: translateX(-24px); opacity: 0; }
    100%{ transform: translateX(0);     opacity: 1; }
  }
  @keyframes slide-in-bottom-key {
    0% { transform: translateY(24px); opacity: 0; }
    100%{ transform: translateY(0);    opacity: 1; }
  }
  @keyframes slide-in-top-key {
    0% { transform: translateY(-24px); opacity: 0; }
    100%{ transform: translateY(0);    opacity: 1; }
  }
</style>